module.exports = __webpack_public_path__ + "img/facebook.55a2a6a5.png";